<template>
  <div>
    <section v-show="sidebarCurrentPanel === 'steps'" class="kp-modular-submenu kp-modular-submenu-tab kp-animate-tab-open">
      <div class="kp-modular-tab pt-page no-fade pt-page-current">
        <header class="kp-modular-title">
          {{ $t('general.labels.steps') }}
        </header>
        <div class="padding-bottom submenu-content">
          <div class="kp-first-component" v-show="stepHasOnlyThanks">
            <div class="kp-first-text">
              {{ $t('general.actions.click') }} {{ $t('general.labels.in').toUpperCase() }}
              <span class="btn_circle btn_circle__text">
                <i class="kp-panel-plus"></i>
              </span>
              {{ $t('general.labels.to').toUpperCase() }} <br> {{ $t('general.actions.add') }} {{ $t('general.labels.your') }} {{ $t('general.labels.first') }} {{ $t('general.labels.step') }}
            </div>
          </div>
          <list></list>
          <button-add></button-add>
        </div>
      </div>
    </section>
    <jump></jump>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from './list/Main.vue';
import ButtonAdd from './list/ButtonAdd.vue';
import Jump from './jump/Main.vue';

export default {
  computed: mapGetters({
    sidebarCurrentPanel: 'sidebarCurrentPanel',
    stepHasOnlyThanks: 'stepHasOnlyThanks',
  }),
  components: {
    List,
    ButtonAdd,
    Jump,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?6b6b8c1c
 **/